<template>
  <div v-if="!isEmpty">
    <div style="padding-top: 0.1em; padding-bottom: 0.1rem" :class="'mr-1 text-xs px-3 text-gray-800 rounded '+bgColor">
      {{ text }}
    </div>
  </div>
</template>
<script>
import { isEmpty } from 'lodash'
export default{
  props: {
    text: String,
    color: String,
  },
  computed: {
    isEmpty() {
      return isEmpty(this.text)
    },
    bgColor(){
      let newColor = 'bg-gray-200'

      if (this.color == 'danger') {
        newColor = 'bg-red-200'
      }else if (this.color == 'warning') {
        newColor = 'bg-orange-200'
      }else if (this.color == 'success') {
        newColor = 'bg-green-200'
      }
      return newColor
    },
  },
}
</script>
